import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function FloatingButtons() {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div className="fixed bottom-6 right-6 z-40 flex flex-col items-end gap-3">
      {/* 견적문의 버튼 */}
      <Link
        to="/quote"
        className="bg-amber-500 hover:bg-amber-600 text-white px-6 py-3 rounded-full font-bold shadow-lg hover:shadow-xl transition-all duration-300 flex items-center space-x-2 whitespace-nowrap cursor-pointer"
      >
        <i className="ri-file-list-3-line text-lg"></i>
        <span>견적문의</span>
      </Link>

      {/* 전화 버튼 그룹 */}
      <div className="flex flex-col items-end gap-2">
        {isExpanded && (
          <>
            <a
              href="tel:02-2263-8248"
              className="bg-slate-700 hover:bg-slate-800 text-white px-5 py-3 rounded-full font-semibold shadow-lg hover:shadow-xl transition-all duration-300 flex items-center space-x-2 whitespace-nowrap cursor-pointer animate-fadeIn"
            >
              <i className="ri-phone-line text-lg"></i>
              <span className="text-sm">재기목형</span>
            </a>
            <a
              href="tel:02-2261-2017"
              className="bg-slate-700 hover:bg-slate-800 text-white px-5 py-3 rounded-full font-semibold shadow-lg hover:shadow-xl transition-all duration-300 flex items-center space-x-2 whitespace-nowrap cursor-pointer animate-fadeIn"
            >
              <i className="ri-phone-line text-lg"></i>
              <span className="text-sm">뉴테크</span>
            </a>
          </>
        )}
        
        <button
          onClick={() => setIsExpanded(!isExpanded)}
          className="bg-slate-800 hover:bg-slate-900 text-white w-14 h-14 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 flex items-center justify-center cursor-pointer"
          aria-label="전화 메뉴"
        >
          <i className={`text-2xl transition-transform duration-300 ${isExpanded ? 'ri-close-line rotate-90' : 'ri-phone-line'}`}></i>
        </button>
      </div>
    </div>
  );
}
